import React, { useState } from 'react';
import { GripVertical, ArrowUp, ArrowDown, X, Grid3x3 } from 'lucide-react';

// Reusable ReorderItems Component
function ReorderItems({ items, onReorder, renderItem, className = '' }) {
  const [draggedIndex, setDraggedIndex] = useState(null);
  const draggedIndexRef = React.useRef(null);

  const handleDragStart = index => {
    setDraggedIndex(index);
    draggedIndexRef.current = index;
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();

    const currentDraggedIndex = draggedIndexRef.current;

    if (currentDraggedIndex === null || currentDraggedIndex === index) return;

    const newItems = [...items];
    const draggedItem = newItems[currentDraggedIndex];

    newItems.splice(currentDraggedIndex, 1);
    newItems.splice(index, 0, draggedItem);

    onReorder(newItems);
    draggedIndexRef.current = index;
    setDraggedIndex(index);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
    draggedIndexRef.current = null;
  };

  const handleDrop = e => {
    e.preventDefault();
    setDraggedIndex(null);
    draggedIndexRef.current = null;
  };

  return (
    <div className="space-y-2">
      {items.map((item, index) => (
        <div
          key={index} // Use react-hook-form's internal id
          draggable
          onDragStart={() => handleDragStart(index)}
          onDragOver={e => handleDragOver(e, index)}
          onDragEnd={handleDragEnd}
          onDrop={handleDrop}
          className={`group flex cursor-move items-center gap-3 rounded-lg border border-slate-200 bg-white p-4 transition-all hover:border-slate-300 ${
            draggedIndex === index ? 'scale-95 opacity-40' : ''
          }`}
        >
          <GripVertical className="h-5 w-5 flex-shrink-0 text-slate-400" />

          <div className="min-w-0 flex-1">{renderItem(item, index)}</div>
        </div>
      ))}
    </div>
  );
}

export default ReorderItems;
